export default __webpack_public_path__ + "static/media/011-flip flops.5ff6907d.svg";